<template>
  <div class="formulate-input" v-if="hasLabelOrRequired">
    <label class="formulate-input-label mb-2">
      <small v-if="required" class="text-danger">*</small>
      {{ label || 'Coluna:' }}
    </label>
    <NxInput
      name="etapa"
      type="select"
      v-model="localValue"
      :label="' '"
      :option-groups="listOptions"
      placeholder="Selecione a Coluna"
      :state="state"
      @update:value="handleValueUpdate"
    ></NxInput>
  </div>
  <NxInput
    v-else
    name="etapa"
    type="select"
    v-model="localValue"
    :label="label || 'Coluna:'"
    :option-groups="listOptions"
    placeholder="Selecione a Coluna"
    :state="state"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import NxInput from '../inputs/NxInput.vue'

export default {
  name: 'NxSelectQuadroColuna',
  mixins: [useReactiveModelMixin('value')],
  components: {
    NxInput
  },
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    },
    boardId: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: false,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      listOptions: {},
      selected: null
    }
  },
  computed: {
    hasLabelOrRequired () {
      // Só mostra wrapper com label se label ou required forem passados explicitamente
      return this.label !== null || this.required === true
    }
  },
  created () {
    if (this.boardId) {
      this.onLoadBoardColumns()
    }
  },
  watch: {
    boardId (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.listOptions = {}
        this.localValue = null
        this.onLoadBoardColumns()
      } else if (!newVal) {
        this.listOptions = {}
        this.localValue = null
      }
    },
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      if (newVal !== this.value) {
        this.$emit('update:value', newVal)
      }
    }
  },
  methods: {
    onLoadBoardColumns () {
      if (!this.boardId) {
        console.warn('NxSelectQuadroColuna: boardId is required')
        return
      }
      BoardRepositoryV2.Column_GetAllActive(this.boardId)
        .then((res) => {
          let activeOptions = this.filterAndReduce(res, (x) => !x.inative)
          let filedOptions = this.filterAndReduce(res, (x) => x.inative)

          let options = []

          if (this.onlyActive) {
            options = {
              Ativas: activeOptions
            }
          } else {
            options = {
              Ativas: activeOptions,
              Inativas: filedOptions
            }
          }

          this.listOptions = options
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Etapas', 'Erro')
          console.error(err)
        })
    },
    filterAndReduce (res, condition) {
      return res.data.content
        .filter((x) => x.id != null && condition(x))
        .reduce((acc, x) => {
          acc[x.id] = x.nome
          return acc
        }, {})
    },
    handleValueUpdate (val) {
      this.localValue = val
      this.$emit('update:value', val)
      // Limpa o estado quando um valor é selecionado
      if (val && this.state === false) {
        this.$emit('clear-state')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectQuadroColuna.vue